import { render } from "./Dialogs.vue?vue&type=template&id=61a521ae&scoped=true&lang=pug"
import script from "./Dialogs.js?vue&type=script&lang=js&external"
export * from "./Dialogs.js?vue&type=script&lang=js&external"

import "./Dialogs.vue?vue&type=style&index=0&id=61a521ae&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61a521ae"]])

export default __exports__